import moment from 'moment'
import { createI18n } from 'vue-i18n/dist/vue-i18n.cjs'

import en_US from '@/locales/en-US'
import es_ES from '@/locales/es-ES'
import pt_BR from '@/locales/pt-BR'

moment.locale('es')

export const i18n = createI18n({
  locale: 'es',
  fallbackLocale: 'es',
  messages: {
    'en': en_US.messages,
    'es': es_ES.messages,
    'pt': pt_BR.messages,
  },
})
